import { render, staticRenderFns } from "./personalPrivacy.vue?vue&type=template&id=243e40fc"
import script from "./personalPrivacy.vue?vue&type=script&lang=js"
export * from "./personalPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports